import { z } from 'zod'
import { toTypedSchema } from '@vee-validate/zod'
import { BRAZILIAN_STATES } from '@/constants/brazilianStates'

const phoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/

const validations = {
  string: (errorMessage) => z.string().nonempty(errorMessage),
  select: (errorMessage) =>
    z
      .string()
      .nullable()
      .refine((val) => val !== null && val !== '', {
        message: errorMessage,
      }),
  min: (errorMessage, min) => z.string().min(min, errorMessage),
  regex: (errorMessage, regex) => z.string().regex(regex, errorMessage),
  state: (errorMessage) =>
    z
      .string()
      .nullable()
      .refine(
        (val) => {
          if (val === null || val === '') return false
          const validStates = BRAZILIAN_STATES.map((state) => state.value)
          return validStates.includes(val)
        },
        {
          message: errorMessage,
        },
      ),
  profession: (errorMessage, professionOptions) =>
    z
      .string()
      .nullable()
      .refine(
        (val) => {
          if (val === null || val === '') return false
          const validProfessions = professionOptions.map(
            (profession) => profession.value,
          )
          return validProfessions.includes(val)
        },
        {
          message: errorMessage,
        },
      ),
}

export const createCompleteProfileFormSchema = (t, professionOptions = []) =>
  toTypedSchema(
    z.object({
      firstName: validations.string(t('validation.required')),
      lastName: validations.string(t('validation.required')),
      phoneNumber: validations.regex(t('validation.phone'), phoneRegex),
      profession: validations.profession(
        t('validation.choose_one'),
        professionOptions,
      ),
      crmState: validations.state(t('validation.choose_one')),
      crmNumber: validations.min(t('validation.required'), 3),
    }),
  )
